



















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import { IChatRoomItem, IDetail, ICount } from "@/api/types";
import Barrage from "@/components/barrage/Index.vue";
import { IBarrageItem } from "@/components/barrage/type";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { recordVideo } from "@/api/dataCollect";
@Component({
  components: {
    Barrage
  }
})
export default class VideoBox extends Vue {
  @Prop()
  detail!: IDetail;
  @Prop()
  liveMute!: number | null;
  @Prop()
  countJson!: ICount;
  @Prop()
  barrageList!: IChatRoomItem[];
  @Prop()
  showBarrage!: boolean;
  @Prop()
  showBarrageName!: boolean;
  // 方便模板使用
  dayjs = dayjs;
  // eslint-disable-next-line
  myPlayer: any = null;

  get appIdFromUA() {
    return this.$store.state.appIdFromUA;
  }

  get hideDetailViewCount() {
    return this.$store.state.hideDetailViewCount;
  }

  get infoSynopsis() {
    if (this.$store.state.appId != 1) {
      return this.detail.synopsis || "";
    }

    if (this.detail && this.detail.synopsis) {
      const strArr = this.detail.synopsis.split("\r\n");
      const newStrArr = strArr.map(item => {
        return `<p>${item}</p>`;
      });
      return newStrArr.join("");
    } else {
      return "";
    }
  }

  @Watch("detail", { immediate: true, deep: true })
  detailChanged(value: IDetail) {
    if (value.videoType != "iframe" && value.bannerVideo) {
      this.$nextTick(() => {
        console.log(videojs);
        this.initVideo();
      });
    }
  }

  // 是否显示倒计时
  showCountdown = false;
  // 倒计时时分秒
  countdownTime: string[] = [];

  get showBarrageList(): IBarrageItem[] {
    if (this.barrageList) {
      return this.barrageList.map(item => {
        return {
          content: this.showBarrageName
            ? this.isAnonymaous(item) + item.content
            : item.content
        };
      });
    }
    return [];
  }

  mounted() {
    // this.detail.serverTime || dayjs().format("YYYY-MM-DD HH:mm:ss"),
    this.calculateStartTime(
      dayjs().format("YYYY-MM-DD HH:mm:ss"),
      this.detail.onlineTime
    );
  }
  // 初始化视频
  initVideo() {
    // eslint-disable-next-line
    const _this = this;
    if (this.myPlayer) return;
    this.myPlayer = videojs(
      "video",
      {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,
        autoplay: true,
        //静音播放
        muted: Boolean(this.liveMute),
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        //  width: "100%",
        //设置视频播放器的显示高度（以像素为单位）
        //  height: "100%",
        // url
        poster: _this.detail.bannerImg, // 封面图片
        sources: [
          {
            src: _this.detail.bannerVideo
          }
        ],
        playbackRates: [0.5, 1, 1.5, 2] //倍速播放
      },
      function onPlayerReady() {
        videojs.log("Your player is ready!"); // 比如： 播放量+1请求

        this.on("ended", function() {
          videojs.log("Awww...over so soon?!");
        });
      }
    );
    this.myPlayer.on("fullscreenchange", (e: any) => {
      console.log("全屏");
      this.$store.state.videoFullScreen = !this.$store.state.videoFullScreen;
    });
    setTimeout(() => {
      recordVideo({
        news: this.detail,
        sourceType: "news",
        ElVideoName: "#video_html5_api"
      });
    }, 100);
  }

  isAnonymaous(data: IChatRoomItem) {
    if (data.type === 0) {
      return data.name ? data.name + " : " : "";
    } else if (data.type === 1) {
      return data.anonymousName ? data.anonymousName + " : " : "";
    }
  }

  get showOnlineTime(): boolean {
    const onlineTime = new Date(this.detail.onlineTime.replace(/-/g, "/")); // 传入直播开始时间
    const nowTime = new Date(); // 获取当前时间
    const timeDifference = onlineTime.getTime() - nowTime.getTime(); // 时间差的毫秒数
    if (timeDifference <= 0) {
      return false;
    }
    return true;
  }

  removeList(length: number) {
    this.$emit("removeList", length);
  }

  // 计算当前距离播放时间是否小于100小时
  calculateStartTime(serverTime: string, startTime: string, timer?: number) {
    if (!startTime) return;
    const nowTime = serverTime ? dayjs(serverTime).unix() * 1000 : Date.now(),
      start = dayjs(startTime).unix() * 1000,
      // 当前时间更新
      newServerTime = nowTime + 1000;

    if (start < nowTime) {
      clearTimeout(timer);
      return;
    }
    timer = setTimeout(() => {
      // 100小时及以内开播 显示倒计时
      if (start - nowTime <= 100 * 60 * 60 * 1000 && start > nowTime) {
        const unixMinus = start - nowTime;
        this.showCountdown = true;
        this.countdownTime = this.transferTime(unixMinus / 1000);
      } else {
        this.showCountdown = false;
      }
      this.calculateStartTime(
        dayjs(newServerTime).format("YYYY-MM-DD HH:mm:ss"),
        startTime,
        timer
      );
      clearTimeout(timer);
    }, 1000);
  }

  // 将秒转为时分秒
  transferTime(second: number): string[] {
    if (Number(second) && second > 0) {
      second = parseInt(String(second)); // 舍去秒数以后的小数位
    } else {
      return ["00", "00", "00"];
    }

    // 计算时分秒
    const s = second % 60,
      m = ((second - s) % 3600) / 60,
      h = parseInt(String(second / 3600));

    // 优化输出
    function fn(num: number) {
      return num >= 10 ? String(num) : "0" + num;
    }
    return [fn(h), fn(m), fn(s)];
  }
}
